// extracted by mini-css-extract-plugin
module.exports = {"alignImage":"style_alignImage__7pHm2","contentPadding":"style_contentPadding__PCTor","containerMargin":"style_containerMargin__4B933"};